import { Image, Text } from '@customerio/pluma-components/react';
import { ImgComparisonSlider as BaseImgComparisonSlider } from '@img-comparison-slider/react';
import clsx from 'clsx';
import { isEmptyString } from '@/utils/string';

import * as styles from './image-comparison.css';

type ImageComparisonProps = {
  height?: string;
  direction?: 'horizontal' | 'vertical';
  beforeUrl: string;
  afterUrl: string;
  type?: 'before' | 'after' | 'side-by-side';
  beforeLabel?: string;
  afterLabel?: string;
};

export const ImageComparison = ({
  height = '100%',
  direction = 'horizontal',
  beforeUrl,
  afterUrl,
  type = 'side-by-side',
  beforeLabel,
  afterLabel,
}: ImageComparisonProps) => {
  const beforeFigureProps = { height, direction, url: beforeUrl, label: beforeLabel };
  const afterFigureProps = { height, direction, url: afterUrl, label: afterLabel };

  if (type === 'before') return <Figure {...beforeFigureProps} />;
  if (type === 'after') return <Figure {...afterFigureProps} />;

  return (
    <BaseImgComparisonSlider direction={direction} className={styles.imgComparisonSlider}>
      <Figure slot="first" {...beforeFigureProps} />
      <Figure slot="second" {...afterFigureProps} />
    </BaseImgComparisonSlider>
  );
};

type FigureProps = {
  slot?: 'first' | 'second';
  direction: 'horizontal' | 'vertical';
  url: string;
  height: string;
  label?: string;
};

function Figure({ slot, direction, url, height, label }: FigureProps) {
  const position = direction === 'vertical' && slot === 'second' ? 'bottom' : 'top';
  const align = direction === 'vertical' && slot === 'first' ? 'second' : slot;

  return (
    <figure slot={slot} className={styles.figure}>
      <Image className={styles.previewImage} style={{ height }} src={url} alt="" />
      {!isEmptyString(label) ? (
        <Text
          as="figcaption"
          className={clsx(
            styles.figcaption,
            position === 'top' ? styles.figcaptionPositionTop : styles.figcaptionPositionBottom,
            align === 'second' ? styles.figcaptionAlignSecond : styles.figcaptionAlignFirst,
          )}
        >
          {label}
        </Text>
      ) : null}
    </figure>
  );
}
